import styled from 'styled-components';
import Icon from '../Icon';

interface SelectProps {
  $large: boolean;
}

export const Container = styled.div`
  display: inline-block;
  position: relative;
  width: fit-content;
`;

export const Select = styled.select<SelectProps>`
  appearance: none;
  background: ${({ theme }) => theme.co.neutral99};
  border: 3px solid ${({ theme }) => theme.co.neutral20};
  border-radius: ${({ theme }) => theme.bo.small};
  font-family: ${({ theme }) => theme.DEPRECATED_ty.boing};
  font-size: ${({ theme, $large }) =>
    $large ? theme.DEPRECATED_ty.large : theme.DEPRECATED_ty.mediumLarge};
  font-weight: ${({ theme, $large }) =>
    $large ? theme.DEPRECATED_ty.bold : theme.DEPRECATED_ty.mediumWeight};
  padding: ${({ theme, $large }) =>
    $large
      ? `${theme.sz.s2} ${theme.sz.s10} ${theme.sz.s2} ${theme.sz.s4}`
      : `${theme.sz.s1} ${theme.sz.s8} ${theme.sz.s1} ${theme.sz.s2}`};
  text-transform: ${({ $large }) => ($large ? 'uppercase' : 'none')};
`;

export const Caret = styled(Icon)<SelectProps>`
  pointer-events: none;
  position: absolute;
  right: ${({ theme, $large }) => ($large ? theme.sz.s4 : theme.sz.s2)};
  top: calc(50% - ${({ theme }) => theme.sz.s3});

  & > svg {
    font-size: ${({ theme, $large }) => ($large ? theme.sz.s6 : theme.sz.s5)};
  }
`;
